module.exports = __webpack_public_path__ + "fonts/avenir/c4352a95-7a41-48c1-83ce-d8ffd2a3b118.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/avenir/c4352a95-7a41-48c1-83ce-d8ffd2a3b118.woff
// module id = 20
// module chunks = 0